export default __webpack_public_path__ + "static/media/criteo-partner-badge-v2.5cc7dd88.png";